import React, { useState, useCallback, useEffect, useRef, forwardRef } from 'react'
import { useMount } from 'react-use'
import { Spin, Select, Avatar, Icon, message, Tooltip } from 'antd'
import styles from './selectProduct.module.scss'
import debounce from 'lodash/debounce'
import * as apis from '@/apis'
import * as services from '@/models/products/services'

function SelectProduct({
  onChange,
  value: product = null
}, ref) {
  const [fetching, setFetching] = useState(false)
  const [list, setList] = useState([])
  const searchProduct = useRef(debounce(async value => {
    setFetching(true)

    try {
      const result = await apis.searchProduct(value)
      setList(result.data)
    } catch (err) {
      message.info('请求出现错误')
    }

    setFetching(false)
  }, 500), []).current

  const handleChange = useCallback(value => {
    const selected = list.find(item => item._id === value)

    onChange(selected)
    setFetching(false)
    setList([])
  })

  useEffect(() => {
    (async () => {
      if (product && typeof product === 'string') {
        const result = await services.getProduct(product)

        onChange(result)
      }

      return () => { }
    })()
  }, [])

  if (product) {
    return (
      <div className={styles.product}>
        <Avatar shape="square" size={30} className={styles.avatar} src={product.cover}></Avatar>
        <div className={styles.propductName}>{product.name}</div>
        <Tooltip title="重新选择">
          <Icon className={styles.clearIcon} type="close-circle" onClick={() => onChange(null)} />
        </Tooltip>
      </div>
    )
  }

  return (
    <Select
      showSearch
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={false}
      maxTagCount={1}
      loading={fetching}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      suffixIcon={<Icon type="search" />}
      placeholder="请输入产品关键字"
      onSearch={searchProduct}
      onChange={handleChange} >
      {list.map(item => (
        <Select.Option key={item._id}>
          <div className={styles.product}>
            <Avatar shape="square" size={30} className={styles.avatar} src={item.cover}></Avatar>
            <div className={styles.propductName}>{item.name}</div>
          </div>
        </Select.Option>
      ))}
    </Select>
  )
}
export default forwardRef(SelectProduct)